module.exports = __webpack_public_path__ + "img/iriomote_16.b451a601.jpg";